import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Results } from './components';
import useSurvey from './useSurvey';

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: theme.spacing(3)
  }
}));

const SurveyDesign = props => {
  const { className, ...rest } = props;
  const survey = useSurvey();
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.content}>
        <Results survey={survey} showNav={true} />
      </div>
    </div>
  );
};

export default SurveyDesign;
